import { observable, toJS } from "mobx";
import moment from "moment";

export const store = observable({
  content: "",
  updateId: -1,
  value: moment(),
  selectedValue: moment(),
  selectedChannel: [],
  companyChannelHandlerList: [],
  imageUrl: null,
  selectedChannelStyle: false,
  selectedChannelId: 0,

  isSentTab: false,
  // filtering
  activeFilters: ["Content"],
  filterContent: null,
  filterStartDate: null,
  filterEndDate: null,
  filterChannel: null,
  filterAgent: null,
  // subs posts
  postsFromSubs: new Map()
});

export function EditPost(id, content, selectedChannel, value, imageUrl) {
  store.updateId = id;
  store.content = content;
  store.selectedChannel.clear();
  store.selectedChannel.push(selectedChannel);
  store.selectedValue = value;
  store.imageUrl = imageUrl;
}

export function ResetInput() {
  store.updateId = -1;
  store.content = "";
  store.selectedChannel.clear();
  store.selectedValue = moment();
  store.imageUrl = null;
}

export function GetFilter() {
  const dateFormat = "YYYY-MM-DD";
  const filter = {
    agent: store.filterAgent ? { id: store.filterAgent.id } : null,
    searchContent: store.filterContent ? store.filterContent : null,
    searchChannel: store.filterChannel ? { id: store.filterChannel.id } : null,
    startTime: store.filterStartDate
      ? store.filterStartDate.format(dateFormat)
      : null,
    endTime: store.filterEndDate ? store.filterEndDate.format(dateFormat) : null
  };
  return filter;
}

export function AddPostFromSubs(post) {
  store.postsFromSubs.set(post.id, post);
}

export function GetPostsFromSubs(isSent) {
  const postsFromSubs = toJS(store.postsFromSubs);
  const filter = GetFilter();
  const hasActiveFilter =
    filter.agent ||
    filter.searchContent ||
    filter.searchChannel ||
    filter.startTime ||
    filter.endTime;

  const posts = [];
  for (const key in postsFromSubs) {
    let includeThisPost = false;
    const post = postsFromSubs[key];

    // filter post
    if (hasActiveFilter) {
      if (filter.agent && post.sentBy && filter.agent.id === post.sentBy.id) {
        includeThisPost = true;
      }
      if (
        filter.searchContent &&
        post.content &&
        filter.searchContent
          .toLowerCase()
          .indexOf(post.content.toLowerCase()) !== -1
      ) {
        includeThisPost = true;
      }
      if (
        filter.searchChannel &&
        post.channel &&
        filter.searchChannel.id === post.channel.id
      ) {
        includeThisPost = true;
      }
      if (filter.startTime && filter.endTime) {
        const postDate = moment(post.dateForPost);
        if (
          moment(filter.startTime).isSameOrBefore(postDate) &&
          moment(filter.endTime).isSameOrAfter(postDate)
        ) {
          includeThisPost = true;
        }
      }
      if (includeThisPost) {
        posts.push(post);
      }
    } else {
      posts.push(post);
    }
  }

  return posts;
}



// WEBPACK FOOTER //
// ./src/module-schedule/store.js